"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Signpost: function() {
        return Signpost;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const Signpost = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M12 23C11.4477 23 11 22.5523 11 22V19H5C4.69622 19 4.4089 18.8619 4.21913 18.6247L2.21913 16.1247C1.92696 15.7595 1.92696 15.2405 2.21913 14.8753L4.21913 12.3753C4.4089 12.1381 4.69622 12 5 12H11V10H4C3.44772 10 3 9.55229 3 9V4C3 3.44772 3.44772 3 4 3H11V2C11 1.44772 11.4477 1 12 1C12.5523 1 13 1.44772 13 2V3H19C19.3038 3 19.5911 3.13809 19.7809 3.37531L21.7809 5.87531C22.073 6.24052 22.073 6.75948 21.7809 7.12469L19.7809 9.62469C19.5911 9.86191 19.3038 10 19 10H13V12H20C20.5523 12 21 12.4477 21 13V18C21 18.5523 20.5523 19 20 19H13V22C13 22.5523 12.5523 23 12 23ZM12 17H19V14H5.48062L4.28062 15.5L5.48062 17H12ZM12 8H18.5194L19.7194 6.5L18.5194 5H12H5V8H12Z",
        fill: "currentColor"
    })
}), "Signpost");
const _default = Signpost;
